/**
 * @generated SignedSource<<f26ef160c8b1a7ff772ddba9d9cc8a14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useIsClubSellingMemberships_club$data = {
  readonly memberships: {
    readonly count: number;
  } | null | undefined;
  readonly " $fragmentType": "useIsClubSellingMemberships_club";
};
export type useIsClubSellingMemberships_club$key = {
  readonly " $data"?: useIsClubSellingMemberships_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsClubSellingMemberships_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useIsClubSellingMemberships_club",
  "selections": [
    {
      "alias": "memberships",
      "args": [
        {
          "kind": "Literal",
          "name": "packageType",
          "value": "MEMBERSHIP"
        },
        {
          "kind": "Literal",
          "name": "saleAvailability",
          "value": "PUBLIC"
        }
      ],
      "concreteType": "PackageConnection",
      "kind": "LinkedField",
      "name": "packages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": "packages(packageType:\"MEMBERSHIP\",saleAvailability:\"PUBLIC\")"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "e94c184e76b70bb62752aab698e34572";

export default node;
